module.exports = __webpack_public_path__ + "img/home_core_icon_01.45708d47.png";